<template>
  <div class="animated fadeIn">
    <Forms v-if="showForm" ref="frmFollowup"
      :title="'Adicionar Follow-up'"
      :showHelp="false"
      :showClearButton="true"
      :showSaveButton="true"
      :showBackButton="true"
      v-on:Clear="onClear"
      v-on:Save="onSave"
      v-on:Back="onBack">
      <div class="form-group row">
        <div class="col-md-12">
          <label for="txtGroup"><small class="text-danger">*</small> Tipo de Evento:</label>
          <div class="input-group">
            <b-form-select ref="frm-input" v-model="form.eventoId.value" :options="form.eventoId.options" class="mb-3" @change="onChangeEvent">
                <template slot="first">
                <option :value="null">{{$lang.Common.PlaceholderSelect}}</option>
              </template>
            </b-form-select>
          </div>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-md-6">
            <label for="txtData"><small v-if="dateRequired" class="text-danger">*</small> Data:</label>
            <div class="input-group">
              <b-form-input type="date"
                            id="txtData"
                            name="txtData"
                            v-model="form.data.value"
                            :required="showFieldHorario"
                            :state="form.data.state"
                            @change="onCheckDate"/>
            </div>
          </div>
        <div class="col-md-6" v-if="showFieldHorario">
          <label for="txtHorario">Horário:</label>
            <FormulateInput
              type="time"
              name="horario"
              input-class="form-control"
              v-model="horario"
              placeholder="Horário"
            />
        </div>
      </div>

      <div class="form-group row pb-2" v-if="showFieldsDespesas">
        <div class="col-md-4">
          <button type="button" class="btn btn-third" @click="onShowDespesasModal" v-b-tooltip.hover title="Adicionar despesas"><i class="fas fa-plus"></i>&nbsp; Adicionar despesas</button>&nbsp;

        </div>
        <div v-if="data.despesas && data.despesas.length > 0" class="col-md pt-2">
          <p>{{data.despesas && data.despesas.length}} Despesas Criadas</p>
        </div>
      </div>

      <div class="form-group row" v-if="showFieldsDeslocamento">
        <div class="col-md-6">
          <label for="txtName"><small class="text-danger">*</small> Km Inicial:</label>
          <div class="input-group">
            <span class="input-group-addon"><i class="fas fa-road"></i></span>
            <b-form-input type="number"
                          min="0"
                          :placeholder="'Digite o Km Inicial'"
                          v-model="form.kmInicial.value"
                          :size="form.kmInicial.maxlength"
                          :required="form.kmInicial.required"
                          :state="form.kmInicial.state"
                          @blur="onCheckKm"></b-form-input>
          </div>
        </div>
        <div class="col-md-6">
          <label for="txtName"><small class="text-danger">*</small> Km Final:</label>
          <div class="input-group">
            <span class="input-group-addon"><i class="fas fa-road"></i></span>
            <b-form-input type="number"
                          min="0"
                          :placeholder="'Digite o Km Final'"
                          v-model="form.kmFinal.value"
                          :size="form.kmFinal.maxlength"
                          :required="form.kmFinal.required"
                          :state="form.kmFinal.state"
                          @blur="onCheckKm"></b-form-input>
          </div>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-md-12">
          <label for="txtDetalhes"><small class="text-danger">*</small> Detalhes:</label>
          <b-form-textarea id="txtDetalhes"
                      name="txtDetalhes"
                      v-model="form.detalhes.value"
                      :placeholder="'Digite os detalhes do follow-up aqui'"
                      :rows="form.detalhes.rows"
                      :size="form.detalhes.maxlength"
                      :noResize="form.detalhes.noResize"></b-form-textarea>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-md-12 pt-2">
          <label for="txtData"><small class="text-danger">*</small> Anexo:</label>
          <div class="input-group" @drop="onUploadDrop" @dragover="onUploadDragover">
            <div class="upload" style="cursor: pointer;" @click="onUploadClick">
              <input
                multiple
                type="file"
                ref="inputFile"
                v-show="false"
                accept="*"
                @change="onFileChange"
              />
              <div><i class="fas fa-file-import" style="font-size: 17px"></i></div>
              <span v-if="!attach">Clique ou arraste aqui para anexar!</span>
              <span v-else>
                <span v-for="(upload, index) in attach" :key="index">{{ upload.name }} &nbsp;</span>
              </span>
            </div>
          </div>
        </div>
      </div>
    <DespesasModal ref="DespesasModal" @onBackDespesas="updateDespesasList" @onBackDespesasFiles="updateDespesasFiles" :listFromParent="despesas"/>
    </Forms>
    <Tables v-else ref="tableGrid"
      :columns="['Data', 'Evento', 'Detalhes', 'Valor Despesas', 'Km', 'Anexos', 'Anexos Despesas', 'Autor', 'Local/Origem', 'Ações']"
      :showTipFooter="false"
      v-on:Load="onLoad">
      <tr v-for="obj in this.objList" v-bind:key="obj.id">
        <TableColumn :IsText="true" v-on:Edit="onEdit(obj)" :status="1" :value="obj.data ? moment(obj.data.replace('+00:00', '')).format('DD/MM/YYYY') : ''"/>
        <TableColumn :IsText="true" v-on:Edit="onEdit(obj)" :status="1" :value="obj.eventoDTO ? obj.eventoDTO.nome: ''"/>
        <TableColumn :IsText="true" v-on:Edit="onEdit(obj)" :status="1" :value="obj.detalhes ? obj.detalhes.toString() : ''"/>
        <TableColumn :IsText="true" v-on:Edit="onEdit(obj)" :status="1" :value="obj.despesas ? somaValorDespesas(obj.despesas) : ''"/>

        <!-- <TableColumn :IsText="true" v-on:Edit="onEdit(obj)" :status="1" :value="(obj.eventoDTO && obj.eventoDTO.nome.toUpperCase() === 'LIGAR' || obj.eventoDTO && obj.eventoDTO.nome.toUpperCase() === 'ENVIAR EMAIL' || obj.eventoDTO && obj.eventoDTO.nome.toUpperCase() === 'OUTROS AGENDAMENTOS') && obj.data ? moment(obj.data).format('DD/MM/yyyy HH:MM:ss') : 'N/D'"/> -->
        <TableColumn :IsCustom="true">
          <td v-if="obj.kmInicial != null && obj.kmFinal" class="text-center" style="font-size: 16px;border:0px;padding-top: 0px;display: contents;">
            <span :id="`popover-target-${obj.id}`" style="margin-left: 30px;"><strong><i class="fas fa-road"></i></strong></span>&nbsp;
          </td>
          <b-popover v-if="obj.kmInicial != null && obj.kmFinal" :target="`popover-target-${obj.id}`" triggers="hover" placement="top">
            <template #title><strong>Deslocamento</strong></template>
            Inicial: <strong>{{obj.kmInicial}}</strong> km <br>
            Final:  <strong>{{obj.kmFinal}}</strong> km <br>
            <hr>
            Total: <strong>{{ (obj.kmFinal - obj.kmInicial) }}</strong> km
          </b-popover>
        </TableColumn>
        <TableColumn :IsCustom="true">
          <td class="text-center" style="font-size: 11px;border:0px;padding-top: 0px;" v-if="obj.arquivo">
            <span style="cursor: pointer;" v-for="(attach, index) in obj.arquivo" :key="index" v-b-tooltip.hover :title="attach.nomeOriginal" @click="onDownloadFile(obj, attach)">
              <span><strong><i class="fas fa-paperclip"></i></strong></span>&nbsp;
            </span>
            <span style="cursor: pointer;" v-if="obj.links" v-b-tooltip.hover :title="obj.links.url" @click="onClickLink(obj.links.url)">
              <span><strong><i class="fas fa-paperclip"></i></strong></span>&nbsp;
            </span>
          </td>
          <td class="text-center" style="font-size: 11px;border:0px;padding-top: 0px;" v-else>&nbsp;</td>
        </TableColumn>
        <TableColumn :IsCustom="true">
          <td class="text-center" style="font-size: 11px;border:0px;padding-top: 0px;" v-if="obj.despesasFiles">
            <span style="cursor: pointer;" v-for="(attach, index) in obj.despesasFiles" :key="index" v-b-tooltip.hover :title="attach.nomeOriginal" @click="onDownloadFileDespesa(obj, attach)">
              <span><strong><i class="fas fa-paperclip"></i></strong></span>&nbsp;
            </span>
          </td>
          <td class="text-center" style="font-size: 11px;border:0px;padding-top: 0px;" v-else>&nbsp;</td>
        </TableColumn>
        <TableColumn :IsText="true" v-on:Edit="onEdit(obj)" :status="1" :value="obj.autor ? obj.autor.toString() : ''"/>
        <TableColumn :IsCustom="true">
          <td class="text-center" style="font-size: 11px;border:0px;padding-top: 0px;"><a :href="getUrl(obj)" target="_blank"><span><strong>{{obj.ip}}</strong></span></a></td>
        </TableColumn>
        <TableColumn :IsActionsButtons="true" :HasChange="false" v-on:Delete="onDelete(obj)" :status="obj.status" />
      </tr>
    </Tables>
    <div class="row" v-if="showForm == false">
      <div class="col-12 pl-4">
        <b-button variant="primary" class="btn-third" @click.prevent="onNew"><i class="fas fa-plus-circle"></i>&nbsp; Adicionar</b-button>
      </div>
    </div>
  </div>
</template>
<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import Tools from '@/components/tools/Tools.js'
import { loading, toast } from '@/shared/utils/UIHelper'
import FollowupRepository from '@/shared/http/repositories/associate/followup'
import EventRepository from '@/shared/http/repositories/configurations/event.js'
import DespesasModal from '@/components/UI/despesasModal/despesas.vue'

const googleMapUrl = 'https://maps.google.com/maps?f=q&source=s_q&hl=pt_BR&q='
const FollowupForm = {
  eventoId: {
    value: null,
    options: [],
    required: true,
    state: null
  },
  data: {
    value: null,
    required: true,
    state: null
  },
  detalhes: {
    value: '',
    maxlength: '280',
    rows: 3,
    required: true,
    state: null
  },
  kmInicial: {
    value: null,
    required: false,
    state: null
  },
  kmFinal: {
    value: null,
    required: false,
    state: null
  },
  horario: {
    value: null,
    defaultValue: '00:00:00',
    required: false,
    state: null,
    placeholder: 'Selecione',
    size: 'sm'
  }
}

const FollowupData = {
  id: null,
  document: null,
  eventoId: null,
  data: null,
  horario: null,
  detalhes: null,
  autor: null,
  ip: null,
  latitude: null,
  longitude: null,
  kmInicial: 0,
  kmFinal: 0,
  despesas: []
}

const PATH_URL_API = process.env.APIBaseURLCore

export default {
  name: 'history',
  mixins: [ActionsForm],
  components: {
    DespesasModal
  },
  props: {
    documentRef: {
      type: String,
      required: false
    }
  },
  data () {
    return {
      document: null,
      data: FollowupData,
      form: FollowupForm,
      showForm: false,
      attach: null,
      despesas: [],
      files: [],
      despesasFiles: [],
      events: [],
      eventsActive: [],
      showFieldsDeslocamento: false,
      showFieldHorario: false,
      isAgendamento: false,
      showFieldsDespesas: false
    }
  },
  computed: {
    dateRequired () {
      let id = null
      if (this.form.eventoId.value) {
        this.form.eventoId.options.forEach(x => x.options.forEach((y) => {
          if (y.mnemonic === 'sys_agendamento') {
            id = y.value
          }
        }))
        if (id === this.form.eventoId.value) {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.form.data.required = true
          return true
        }
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.form.data.required = false
      return false
    },
    horario: {
      get: function () {
        if (this.form.horario.value && this.form.horario.value.length > 5) {
          return this.form.horario.value.substring(0, 5)
        }

        return this.form.horario.valaue
      },
      set: function (value) {
        if (value && value.includes(':') && value.length === 5) {
          this.form.horario.value = value + ':00'
          return
        }

        this.form.horario.value = value
      }
    }
  },
  created () {
    this.onLoadAllEventType()
  },
  methods: {
    getUrl (obj) {
      var result = googleMapUrl + this.latitude + ',' + this.longitude
      if (obj && obj.latitude) {
        result = googleMapUrl + obj.latitude + ',' + obj.longitude
      }
      return result
    },
    onLoadAllFollowup (document) {
      this.document = document
      FollowupRepository.Search(document, this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
        .then(response => {
          this.onResultGrid(response)
        })
        .catch(this.onException)
    },
    onLoad () {
      if (this.document) {
        this.onLoadAllFollowup(this.document)
      }
    },
    onClear () {
      Tools.ClearDataForms(this.form, this.data)
      if (this.$refs.alert) {
        this.$refs.alert.Close()
      }
      this.files = []
      this.attach = null
      this.showFieldsDeslocamento = false
      this.showFieldsDespesas = false
    },
    onNew () {
      this.showForm = true
      this.despesas = []
      this.files = []
      this.attach = null

      this.$nextTick(() => {
        this.$refs['frm-input'].focus()
      })
    },
    onEdit (obj) {
      loading.push()
      Tools.SetValueInForm(this.form, this.data, obj)
      this.form.kmFinal.value = obj.kmFinal
      this.form.eventoId.value = obj.eventoDTO.id
      this.form.data.value = this.moment(obj.data).format('YYYY-MM-DD')
      this.showForm = true
      this.despesas = obj.despesas
      this.data.longitude = this.longitude
      this.data.latitude = this.latitude
      this.data.ip = this.ip
      this.onChangeEvent(obj.eventoDTO.id)
      loading.pop()
    },
    onBack () {
      loading.push()
      this.onClear()
      this.showForm = false
      setTimeout(() => {
        loading.pop()
        this.onLoadAllFollowup(this.document)
      }, 100)
    },
    onCreate () {
      loading.push()
      this.data.id = 0
      this.data.document = this.document
      this.data.longitude = this.longitude
      this.data.latitude = this.latitude
      this.data.ip = this.ip
      if (this.data.data) {
        if (this.data.horario && this.showFieldHorario) {
          this.data.data = this.moment.tz(this.data.data + 'T' + this.data.horario, 'America/Sao_Paulo').format('YYYY-MM-DDTHH:mm')
        } else {
          this.data.data = this.moment.tz(this.data.data + 'T' + this.moment().format('HH:mm:ss'), 'America/Sao_Paulo').format('YYYY-MM-DDTHH:mm')
        }
      }
      let formData = new FormData()
      let json = new Blob([JSON.stringify(this.data)], { type: 'application/json' })
      formData.append('data', json)
      if (this.files && this.files.length > 0) {
        for (let file of this.files) {
          formData.append('file', file)
        }
      } else {
        formData.append('file', [])
      }
      if (this.despesasFiles && this.despesasFiles.length > 0) {
        for (let despesasFile of this.despesasFiles) {
          formData.append('despesasFile', despesasFile)
        }
      } else {
        formData.append('despesasFile', [])
      }

      FollowupRepository.Create(formData)
        .then((response) => {
          if (response.status === 200) {
            toast.success(this.$lang.Common.Alerts.Success)
            this.attach = null
            this.files = []
            this.despesasFiles = []
            this.onBack()
            loading.pop()
          }
        })
        .catch(this.onException)
    },
    onUpdate () {
      loading.push()
      this.data.id = parseInt(this.data.id)
      this.data.document = this.document
      this.data.longitude = this.longitude
      this.data.latitude = this.latitude
      this.data.ip = this.ip
      if (this.data.data !== 'Data inválida') {
        if (this.data.horario && this.showFieldHorario) {
          this.data.data = this.moment.tz(this.data.data + 'T' + this.data.horario, 'America/Sao_Paulo').format('YYYY-MM-DDTHH:mm')
        } else {
          this.data.data = this.moment.tz(this.data.data + 'T' + this.moment().format('HH:mm:ss'), 'America/Sao_Paulo').format('YYYY-MM-DDTHH:mm')
        }
      } else {
        this.data.data = null
      }

      let formData = new FormData()
      let json = new Blob([JSON.stringify(this.data)], { type: 'application/json' })
      if (this.files && this.files.length > 0) {
        for (let file of this.files) {
          formData.append('file', file)
        }
      } else {
        formData.append('file', [])
      }
      if (this.despesasFiles && this.despesasFiles.length > 0) {
        for (let despesasFile of this.despesasFiles) {
          formData.append('despesasFile', despesasFile)
        }
      } else {
        formData.append('despesasFile', [])
      }
      formData.append('data', json)

      FollowupRepository.Update(this.data.id, formData)
        .then((response) => {
          if (response.status === 200) {
            toast.success(this.$lang.Common.Alerts.Success)
            this.attach = null
            this.files = []
            this.despesasFiles = []
            this.onBack()
            loading.pop()
          }
        })
        .catch(this.onException)
    },
    onDelete (obj) {
      loading.push()
      let id = parseInt(obj.id)

      FollowupRepository.Delete(id)
        .then((response) => {
          if (response.status === 200) {
            toast.success(this.$lang.Common.Alerts.Success)
            this.onBack()
            loading.pop()
          }
        })
        .catch(this.onException)
    },
    onLoadAllEventType () {
      this.form.eventoId.options = []
      loading.push()
      EventRepository.GetAllPaging(300, 0)
        .then((response) => {
          if (response.status === 200) {
            let data = response.data.content
            if (data) {
              // let events = []
              this.events = []
              data.forEach(x => {
                if (x.tipoEventoDTO.nome !== 'CRM') {
                  this.events.push({
                    'id': x.id,
                    'nome': x.nome,
                    'tipo': x.tipoEventoDTO.nome,
                    'deslocamento': x.deslocamento,
                    'despesa': x.despesa,
                    'mnemonic': x.mnemonic,
                    'inative': x.inative
                  })
                }
              })

              this.events.sort((a, b) => {
                let typeA = a.tipo.toLowerCase()
                let typeB = b.tipo.toLowerCase()
                if (typeA < typeB) {
                  return -1
                }
                if (typeA > typeB) {
                  return 1
                }
                return 0
              })
            }
          }
        })
        .catch((err) => {
          this.onException(err)
        })
      EventRepository.GetAllActive()
        .then((response) => {
          if (response.status === 200) {
            let data = response.data.content
            if (data) {
              this.eventsActive = []
              data.forEach(x => {
                if (x.tipoEventoDTO.nome !== 'CRM') {
                  this.eventsActive.push({
                    'id': x.id,
                    'nome': x.nome,
                    'tipo': x.tipoEventoDTO.nome,
                    'deslocamento': x.deslocamento,
                    'despesa': x.despesa,
                    'mnemonic': x.mnemonic,
                    'inative': x.inative
                  })
                }
              })
              let opt = []
              this.eventsActive.forEach(x => {
                if (!opt.find(opt => opt.label === x.tipo)) { // Adicionada a verificação x.inative === false
                  let options = []
                  this.eventsActive.forEach(y => {
                    if (y.tipo === x.tipo) { // Adicionada a verificação y.inative === false
                      options.push({ value: y.id, text: y.nome, mnemonic: y.mnemonic })
                    }
                  })
                  if (options.length > 0) { // Verifica se há eventos ativos antes de adicionar à lista
                    opt.push({
                      label: x.tipo,
                      options: options
                    })
                  }
                }
              })
              this.form.eventoId.options = opt
            }
          }
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onShowDespesasModal () {
      this.$refs.DespesasModal.showModal()
    },
    updateDespesasList (despesasList) {
      if (despesasList && despesasList.length) {
        this.data.despesas = despesasList
      }
    },
    onChangeEvent (value) {
      this.showFieldsDeslocamento = false
      this.showFieldsDespesas = false
      this.showFieldHorario = false
      this.isAgendamento = false
      let opt = this.events.find(x => x.id === value)
      if (opt && opt.deslocamento) {
        this.showFieldsDeslocamento = true
      }
      if (opt && opt.despesa) {
        this.showFieldsDespesas = true
      }
      if (opt && opt.mnemonic === 'sys_agendamento') {
        this.showFieldHorario = true
        this.isAgendamento = true
      }
    },
    somaValorDespesas (despesas) {
      if (despesas.length > 0) {
        return this.formatValue(despesas.reduce((total, x) => total + x.valor, 0))
      }
    },
    onCheckKm () {
      if (this.isKmInvalid()) {
        toast.warning('ATENÇÃO: Km Inicial não pode ser maior do que o Km Final!<br>', 'FOLLOW-UP DESLOCAMENTO')
        this.form.kmInicial.value = ''
        this.form.kmFinal.value = ''
      } else if (this.isKmNegative()) {
        toast.warning('ATENÇÃO: A kilometragem não pode ser negativa!<br>', 'FOLLOW-UP DESLOCAMENTO')
        this.form.kmInicial.value < 0 ? (this.form.kmInicial.value = '') : (this.form.kmFinal.value = '')
      } else if (this.isKmZero()) {
        toast.warning('ATENÇÃO: Kilometragem rodada precisa ser maior que 0!<br>', 'FOLLOW-UP DESLOCAMENTO')
        this.form.kmInicial.value = ''
        this.form.kmFinal.value = ''
      }
    },
    isKmInvalid () {
      return this.form.kmInicial.value && this.form.kmFinal.value && this.form.kmInicial.value > this.form.kmFinal.value
    },
    isKmNegative () {
      return this.form.kmInicial.value < 0 || this.form.kmFinal.value < 0
    },
    isKmZero () {
      return this.form.kmInicial.value && this.form.kmFinal.value && this.form.kmFinal.value - this.form.kmInicial.value <= 0
    },
    onCheckDate () {
      if (this.isAgendamento) {
        if (this.moment(this.form.data.value).isBefore(this.moment().subtract(1, 'day'))) {
          toast.warning('ATENÇÃO: Data de agendamento não pode ser anterior a de hoje!<br>', 'FOLLOW-UP AGENDAMENTO')
          this.form.data.value = null
        }
      }
    },
    onUploadClick () {
      this.$refs.inputFile.click()
    },
    onUploadDrop (event) {
      event.preventDefault()
      let files = event.dataTransfer.files
      this.attach = files
      if (files && files.length > 0) {
        for (var i in files) {
          if (files[i].size > 0) {
            this.files.push(files[i])
          }
        }
      }
    },
    onUploadDragover (event) {
      event.preventDefault()
    },
    onFileChange (event) {
      event.preventDefault()
      let files = event.target.files
      this.attach = files
      if (files && files.length > 0) {
        for (var i in files) {
          if (files[i].size > 0) {
            this.files.push(files[i])
          }
        }
      }
    },
    onDownloadFile (obj, file) {
      if (obj && file) {
        FollowupRepository.FileShare(obj.id, file.uuid)
          .then((response) => {
            if (response.status === 200) {
              let data = response.data
              if (data && data.uuid) {
                window.open(`${PATH_URL_API}/arquivos/compartilhados/${data.uuid}/download`)
              }
            }
          })
          .catch(this.onException)
      }
    },
    onDownloadFileDespesa (obj, file) {
      if (obj && file) {
        FollowupRepository.FileShareDespesas(obj.id, file.uuid)
          .then((response) => {
            if (response.status === 200) {
              let data = response.data
              if (data && data.uuid) {
                window.open(`${PATH_URL_API}/arquivos/compartilhados/${data.uuid}/download`)
              }
            }
          })
          .catch(this.onException)
      }
    },
    onClickLink (url) {
      if (url) {
        window.open(`${url}`)
      }
    },
    formatValue (value) {
      let result
      if (value) {
        result = Tools.formatMoneyBR(value.toString())
      }
      return result
    },
    updateDespesasFiles (data) {
      if (data && data.length) {
        this.despesasFiles = data
      }
    }
  }
}
</script>
<style scoped>
.upload {
  border: solid 1px #ccc;
  border-radius: 4px;
  background-color: #efefef;
  padding: 3%;
  width: 100%;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/views/private/associate/tabs/history.vue